var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"ui-control-group terminal-control-group",class:[
    `terminal-control-group--${_vm.direction}`,
    `terminal-control-group--${_vm.size}`,
    { 'terminal-control-group--joined': _vm.joined }
  ],attrs:{"role":"group"}},'div',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }